import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { useSeo } from "@/hooks/useSeo";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { faqs } from "@/mocks/faqs";
import { contactInfo } from "@/mocks/site";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://heianbaoliao.example.com/" },
      { "@type": "ListItem", position: 2, name: "常见问题", item: "https://heianbaoliao.example.com/faq" },
    ],
  },
];

export default function FaqPage() {
  useSeo({
    title: "常见问题 - 信源保护、核实流程与更正机制｜黑暗爆料",
    description:
      "关于黑暗爆料的常见问题：爆料内容从哪来、如何保护爆料人匿名、投稿是否需要证据、被爆料方如何回应、化名与模糊处理的依据，以及发现错误后的更正流程。",
    keywords: "黑暗爆料常见问题,爆料人匿名保护,线索核实流程,内容更正机制,匿名投稿",
    path: "/faq",
    jsonLd,
  });

  useScrollReveal([]);

  return (
    <SiteLayout>
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-content px-4 py-8 md:px-6 md:py-10">
          <Breadcrumbs items={[{ name: "常见问题" }]} />
          <h1 className="mt-5 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            常见问题
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            这些问题大多来自读者来信和线人的顾虑。我们把它们整理出来，是为了让投递和阅读都建立在更清楚的前提上。
          </p>
        </div>
      </div>

      <div className="mx-auto grid max-w-content grid-cols-1 gap-10 px-4 py-10 md:px-6 md:py-12 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <div className="reveal">
            <FaqAccordion items={faqs} defaultOpen={0} />
          </div>
        </div>

        <aside className="lg:col-span-4">
          <div className="reveal space-y-6 lg:sticky lg:top-40">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                <i className="ri-question-answer-line text-2xl" aria-hidden="true"></i>
              </span>
              <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">还有其他疑问？</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                关于投稿、更正或合作的问题，可以通过公开邮箱或投稿入口联系我们。请勿在邮件中附带他人隐私信息。
              </p>
              <p className="mt-4 flex items-center gap-2 rounded-md bg-background-100 px-3 py-2.5 text-xs text-foreground-700">
                <i className="ri-mail-line text-base text-primary-600" aria-hidden="true"></i>
                {contactInfo.email}
              </p>
              <p className="mt-2 text-xs font-label text-foreground-500">{contactInfo.replyTime}</p>
            </div>

            <div className="rounded-lg border border-background-200 bg-secondary-900 p-6 text-background-100">
              <h2 className="flex items-center gap-2 font-heading text-base font-bold text-background-50">
                <i className="ri-arrow-go-back-line text-accent-400" aria-hidden="true"></i>
                更正比爆点更重要
              </h2>
              <p className="mt-3 text-xs leading-relaxed text-background-300">
                我们认为，一篇敢更正的稿件，比一篇永远正确的稿件更值得信任。
              </p>
              <Link
                to="/about"
                className="mt-4 inline-flex items-center gap-2 text-sm font-label text-accent-300 transition-colors hover:text-accent-200 cursor-pointer"
              >
                查看内容原则
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </aside>
      </div>
    </SiteLayout>
  );
}